import React, { useState } from 'react';

const Financiamento: React.FC = () => {
    const [valor, setValor] = useState('');
    const [entrada, setEntrada] = useState('');
    const [taxa, setTaxa] = useState('');
    const [prazo, setPrazo] = useState('');

    const calcularFinanciamento = () => {
        if (!valor || !entrada || !taxa || !prazo) return null;

        const V = parseFloat(valor);
        const E = parseFloat(entrada);
        const i = parseFloat(taxa) / 100 / 12; // Taxa mensal
        const n = parseInt(prazo);

        const financiado = V - E;
        const parcela = financiado * (i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
        const total = parcela * n;
        const juros = total - financiado;

        return {
            financiado: financiado.toFixed(2),
            parcela: parcela.toFixed(2),
            total: total.toFixed(2),
            juros: juros.toFixed(2)
        };
    };

    const resultado = calcularFinanciamento();

    return (
        <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculadora de Financiamento</h3>

            <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Valor do imóvel (R$)
                                <input
                                    type="number"
                                    value={valor}
                                    onChange={(e) => setValor(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="200000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Entrada (R$)
                                <input
                                    type="number"
                                    value={entrada}
                                    onChange={(e) => setEntrada(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="40000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Taxa de juros anual (%)
                                <input
                                    type="number"
                                    value={taxa}
                                    onChange={(e) => setTaxa(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="8"
                                    step="0.1"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Prazo (meses)
                                <input
                                    type="number"
                                    value={prazo}
                                    onChange={(e) => setPrazo(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="360"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    {resultado && (
                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-indigo-900 mb-4">Resultado:</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Valor financiado:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.financiado}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Parcela mensal:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.parcela}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Total de juros:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.juros}</span>
                                </div>
                                <div className="flex justify-between text-lg">
                                    <span className="text-indigo-700">Total a pagar:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.total}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Financiamento;
